import {IOrderModel} from '../../../../src/@interfaces/models/Order/IOrderModel';
import {useWatch} from 'react-hook-form';
import React, {useContext} from 'react';
import {IFormFieldItemPropsContext} from '../../../../src/@interfaces/contexts/IFormFieldItemPropsContext';
import {FormFieldItemPropsContext} from '../../../../src/contexts/FormFieldItemPropsContext';
import FormattedPrice from '../../../../src/components/FormattedPrice/FormattedPrice';

export function ProductPriceField({rowIndex: index}: { rowIndex: number }) {
    const {
        control,
        fieldName,
        modelOptions = {}
    } = useContext<IFormFieldItemPropsContext<IOrderModel> | null>(FormFieldItemPropsContext) ?? {};

    const products = useWatch({control, name: fieldName as 'products'});
    const productId = products?.[index]?.product_id;

    const product = productId ? (modelOptions?.products as any).find(
            ({value}: { value: number }) => value === productId
    ) : null;

    const price = !product?.price ? 0 : (product.price / 100);

    return <span className="ms-2">
        {
            product?.unit?.title ?
                    <>
                        <FormattedPrice amount={price}/> / {product?.unit?.title}
                    </> :
                    <FormattedPrice amount={price}/>
        }

    </span>;
}
